document.addEventListener('DOMContentLoaded', function() {
    const wrappers = document.querySelectorAll('.cases__wrapper');
    let counter = 0;
    Array.from(wrappers).forEach(wrapper => {
        if (counter % 2 == 0) {
            const contents = wrapper.querySelectorAll('.cases__content');
            Array.from(contents).forEach(content => {
                content.classList.add('revert');
            });
        }
        counter++;
    });
});

(function(){
    const i18n = window.axamitFormI18n || {}

    function applyFilter(slug) {
        const items = document.querySelectorAll('.cases__wrapper');
        items.forEach(item => {
            const tags = (item.getAttribute('data-tags') || '').split(',').filter(Boolean);
            const match = slug === 'all' || tags.includes(slug);
            item.style.display = match ? '' : 'none';
            item.toggleAttribute('hidden', !match);
        });

        const btnToActivate = document.querySelector(`.cases__filter[data-filter="${slug}"]`);
        if (btnToActivate) {
            document.querySelectorAll('.cases__filter').forEach(b => {
                b.classList.toggle('is-active', b === btnToActivate);
                b.setAttribute('aria-selected', b === btnToActivate ? 'true' : 'false');
            });
        }

        document.querySelectorAll('.cases__dropdown-item').forEach(li => {
            const active = li.getAttribute('data-filter') === slug;
            li.classList.toggle('is-active', active);
            li.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        const ddBtn = document.querySelector('.cases__dropdown-button');
        if (ddBtn) {
            const activeLi = document.querySelector(`.cases__dropdown-item[data-filter="${slug}"]`);
            let label = activeLi ? activeLi.textContent.trim() : (i18n.all || 'All');
            if (label === (i18n.all || 'All')) label = i18n.allCases || 'All cases';
            if (label.startsWith('#')) label = label.slice(1);
            ddBtn.textContent = label;
        }
    }

    document.addEventListener('click', function(e){
        const btn = e.target.closest('.cases__filter');
        if (!btn) return;
        const slug = btn.getAttribute('data-filter');

        document.querySelectorAll('.cases__filter').forEach(b => {
            b.classList.toggle('is-active', b === btn);
            b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });

        applyFilter(slug);
        const url = new URL(window.location);
        if (slug === 'all') url.searchParams.delete('case_tag');
        else url.searchParams.set('case_tag', slug);
        window.history.replaceState({}, '', url);
    });

    const dd = { wrap: null, btn: null, list: null };

    function setupDropdown(){
        dd.wrap = document.querySelector('.cases__dropdown');
        if (!dd.wrap) return; // чипсы без дропдауна — ок
        dd.btn = dd.wrap.querySelector('.cases__dropdown-button');
        dd.list = dd.wrap.querySelector('.cases__dropdown-list');
        if (!dd.btn || !dd.list) return;

        function open(){
            dd.btn.setAttribute('aria-expanded', 'true');
            dd.list.setAttribute('data-open', 'true');
            dd.list.setAttribute('aria-hidden', 'false');
        }
        function close(){
            dd.btn.setAttribute('aria-expanded', 'false');
            dd.list.setAttribute('data-open', 'false');
            dd.list.setAttribute('aria-hidden', 'true');
        }

        dd.btn.addEventListener('click', function(){
            const expanded = dd.btn.getAttribute('aria-expanded') === 'true';
            expanded ? close() : open();
        });

        dd.list.addEventListener('click', function(e){
            const li = e.target.closest('.cases__dropdown-item');
            if (!li) return;
            const slug = li.getAttribute('data-filter');
            applyFilter(slug);
            const url = new URL(window.location);
            if (slug === 'all') url.searchParams.delete('case_tag');
            else url.searchParams.set('case_tag', slug);
            window.history.replaceState({}, '', url);
            close();
        });

        document.addEventListener('click', function(e){ if (!dd.wrap.contains(e.target)) close(); });
        document.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
    }

    document.addEventListener('DOMContentLoaded', function(){
        setupDropdown();
        const url = new URL(window.location);
        const initial = url.searchParams.get('case_tag') || 'all';
        applyFilter(initial);
    });
})();